/**
 * Search Module
 *
 * Description
 * -----------
 * To manipulate the site search forms, adding
 * functionality such as a clickable magnifying glass icon to
 * initiate the search. Additional checks can be made later 
 * for specific forms and perform additional actions.
 *
 * General JS Theme Purpose
 * ------------------------
 * To deprecate usage of 1) duplicate CDATA scripts found 
 * in /%locale%/_build/navigation.xml and 2) 'onclick'
 * attributes added directly to HTML markup.
 *
 */

(function ($) {
  'use strict';

  jQuery.fn.extend({
    lxk_theme_search: function(){

      var search = function(element, options){
        this.element = element;
        this.options = options;
        this.metadata = $(element).data('search-options');
        this.searchName = $(element).data('search-name');
      };

      search.prototype = {

        defaults: {
        },

        events: {
          init: 'search.init'
        },

        debug: false,

        logEvents: function() {
          var _ = this,
            evtList = '';

          for ( var key in _.events ) {
            if ( _.events.hasOwnProperty(key) ) {
              evtList = (evtList === '') ? evtList + _.events[key] : evtList + ' ' + _.events[key];
            }
          }

          $(_.element).on(evtList, function(event) {
            console.log(event.type + '.' + event.namespace);
          });
        },

        setSettings: function() {
          var _ = this;

          // merge defaults and other settings/options
          _.settings = $.extend({}, _.defaults, _.options, _.metadata);
        },

        handlers: function() {
          var _ = this;

          // handle click events on a tags within the form
          $(_.element).find('.input-group a').on('click', function(){
            // submit form
            $(_.element).submit();
            return false;
          });
        },

        init: function() {
          var _ = this;

          _.setSettings();
          _.handlers();

          // set up logging, if applicable
          if ( window.console && _.debug ) {
            _.logEvents();
          }
        }

      };

      search.defaults = search.prototype.defaults;

      $.fn.Search = function(options) {
        return this.each(function(i, element) {
          new search(element, options).init();
        });
      };

      window.search = search;

      $(window).on('load', function() {
        $('[data-search-name]').Search();
      });

    }

  });

  jQuery(document).lxk_theme_search();

})(jQuery);
